/* Lazy Shopify video, see snippets/lazy-video.liquid */
  (function () {
    if (window.__lazyVideoInit) return;
    window.__lazyVideoInit = true;

    function pickSrc(el) {
      return window.matchMedia('(max-width: 749px)').matches ? el.dataset.srcMobile : el.dataset.srcDesktop;
    }

    function load(el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = 'true';
      el.src = pickSrc(el);
      el.load();
      if (el.hasAttribute('data-autoplay')) {
        var p = el.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function init() {
      var videos = document.querySelectorAll('video[data-lazy-video]');
      if (!('IntersectionObserver' in window)) {
        videos.forEach(load);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          if (entry.isIntersecting) {
            load(el);
            if (el.hasAttribute('data-autoplay') && el.paused) {
              var p = el.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (el.dataset.loaded && el.hasAttribute('data-autoplay') && !el.paused) {
            el.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      videos.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();